export default "__VITE_ASSET___4vk$Fu5__"